import { render, staticRenderFns } from "./RequirementStatuses.vue?vue&type=template&id=5dcfc030&"
import script from "./RequirementStatuses.vue?vue&type=script&lang=js&"
export * from "./RequirementStatuses.vue?vue&type=script&lang=js&"
import style0 from "./RequirementStatuses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports